import React from 'react';
import { observer } from 'mobx-react-lite';

import useStore from '@hooks/useStore';
import { IHeaderProps } from '@components/header/types';
import useStyles from '@components/header/desktop/styles';
import DesktopLogoSvg from '@assets/images/logo-accountpayables.svg';
import LogoSura from '@assets/images/logo_sura.svg';

const HeaderDesktop: React.FC<IHeaderProps> = ({ flat = false }) => {
  const {
    links: {
      flags,
      coBrandingConfig: { logo },
    },
    ui,
    sura,
  } = useStore();
  const css = useStyles({ mobile: ui.isMobileScreen, isSura: sura.isSura });

  const logoSrc = logo ? logo : sura.isSura ? LogoSura : DesktopLogoSvg;

  const Logo = () => <img src={logoSrc} alt="BrandLogo" className={css.logo} />;

  if (flags.isRequesting) return null;

  return (
    <div className={`${css.header} ${flat ? 'flat' : 'isSura'}`}>
      <div className={css.content}>
        <Logo />
      </div>
    </div>
  );
};

export default observer(HeaderDesktop);
